import { Component, Inject, Input, OnInit } from '@angular/core';
import { format } from 'date-fns';

import { VtmnButtonSizeEnum } from '~/component/buttons/vtmn-button/enum/vtmn-button-size.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { RatingSizeEnum } from '~/component/vtmn-rating/enums/RatingSize.enum';
import { CDN_ROOT } from '~/core/core.module';
import { LocaleService } from '~/i18n/services/locale.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Component({
  selector: 'app-activity-reviews-detail',
  templateUrl: './activity-reviews-detail.html',
  styleUrls: ['./activity-reviews-detail.scss'],
})
export class ActivityReviewsDetailComponent implements OnInit {
  @Input() public activityMedia?: string;
  @Input() public activityName?: string;
  @Input() public isReviewsPage: boolean;
  @Input() public review;

  public readonly activityRatingReportToggle =
    ToggleNameEnum.ActivityRatingReport;
  public readonly activityRatingTranslateToggle =
    ToggleNameEnum.ActivityRatingTranslate;
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly ratingSizeEnum = RatingSizeEnum;
  public readonly vtmnButtonSize = VtmnButtonSizeEnum;

  constructor(
    @Inject(CDN_ROOT) private readonly cdnRoot: string,
    private readonly localeService: LocaleService
  ) {}

  ngOnInit() {
    if (!this.activityName || this.activityName === '') {
      this.activityName = this.review.activityName;
    }

    if (!this.activityMedia || this.activityMedia === '') {
      this.activityMedia = this.review.activityMedia;
    }
  }

  public get cssStyle(): object {
    if (this.activityMedia === '' || !this.activityMedia) {
      return {
        'background-image': `url(${this.getDefaultImageUrl()})`,
      };
    }

    return {
      'background-image': `url(${this.activityMedia})`,
    };
  }

  public get customDetailsBlockClass(): string {
    const classesArray: string[] = [];

    if (this.isReviewsPage === true) {
      classesArray.push('activity-review__reviews-page');
    }
    if (!this.activityName) {
      classesArray.push('activity-review__content-margin');
    }

    return classesArray.join(' ');
  }

  public get reviewHasAnswers(): boolean {
    return this.review.answers?.length > 0;
  }

  public publisherDateFormatted(type): string {
    return format(new Date(type), 'dd/MM/yyyy', {
      locale: this.localeService.dateLocale,
    });
  }

  private getDefaultImageUrl(): string {
    return `${this.cdnRoot}/common/default.jpg`;
  }
}
